import { IntakeLabelCollection } from '../../entities/intake-label.interface';
export const AishEducationLabels: IntakeLabelCollection = {
  educationLevel: {
    label: 'What education or training have you completed?',
    onBehalfLabel: 'What education or training has <<oboName>> completed?',
  },
  collegeUniversityName: {
    label: 'School/provider',
  },
  programOfStudy: {
    label: 'Program of study',
  },
  courseLevelCompleted: {
    label: 'Course level completed',
  },
  lastYearAttended: {
    label: 'Last year attended',
    // label: 'Year of completion',
  },
  degreeDiplomaObtained: {
    label: 'Degree/diploma/certificate obtained',
  },
  schoolProvider: {
    label: 'School/provider',
  },
  dateStarted: {
    label: 'Date started',
  },
  expectedStartDate: {
    label: 'Expected start date',
  },
  expectedCompletionDate: {
    label: 'Expected completion date',
  },
  goals: {
    label: 'What are your goals upon completing training?',
    onBehalfLabel: 'What are their goals upon completing training?',
  },
  stepsToFindWork: {
    label: 'What steps have you taken to find training that is compatible with your disability?',
    onBehalfLabel: 'What steps has <<oboName>> taken to find training that is compatible with their disability?',
  },
  currentlyAttendingEducationOrTraining: {
    label: 'Are you currently attending an education or training program?',
    onBehalfLabel: 'Is <<oboName>> currently attending an education or training program?',
  },
  planAttendingEducationOrTraining: {
    label: 'Do you have plans to take further training or upgrading in the near future?',
    onBehalfLabel: 'Does <<oboName>> have plans to take further training or upgrading in the near future?',
  },
  trainingGoals: {
    label: 'What are your goals upon completing training?',
    onBehalfLabel: 'What are their goals upon completing training?',
  },
};
